import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfigUtils } from '../utils/configUtils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PedidoServices{
  static cachePedido:any={};
  static nuevoPedido:boolean=false;
  static filtroReporte:any={};

  constructor(public http: HttpClient){}

  getPedidos(filtro){
    let url = ConfigUtils.getUrlFromEndPointName('pedido');
    url+='/getByFiltro';
    return this.http.post<any>(url,filtro);
  }
}




